import React, { useState, useMemo } from 'react';
import LapChart from './LapChart';

const LapDetailsSection = ({ lapDetails }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const lapMetrics = useMemo(() => {
        if (!lapDetails || lapDetails.length === 0) return null;

        // Calculate average duration
        const durations = lapDetails
            .filter(lap => lap.durationSeconds !== null)
            .map(lap => lap.durationSeconds);
        
        const avgDuration = durations.length > 0 
            ? durations.reduce((a, b) => a + b) / durations.length 
            : 0;

        // Calculate metrics for each lap
        const metricsWithComparison = lapDetails.map((lap, index) => {
            let cumulativeTime = 0;
            for (let i = 0; i <= index; i++) {
                if (lapDetails[i].durationSeconds !== null) {
                    cumulativeTime += lapDetails[i].durationSeconds;
                }
            }

            const diffFromAvg = lap.durationSeconds !== null 
                ? lap.durationSeconds - avgDuration 
                : 0;

            return {
                ...lap,
                cumulativeTime,
                diffFromAvg,
                pace: lap.durationSeconds !== null ? ((diffFromAvg / avgDuration) * 100).toFixed(0) : 'N/A'
            };
        });

        return {
            metrics: metricsWithComparison,
            avgDuration
        };
    }, [lapDetails]);

    if (!lapDetails || lapDetails.length === 0) {
        return null;
    }

    const formatTime = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = Math.floor(seconds % 60);
        if (hours > 0) {
            return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        } else {
            return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        }
    };

    return (
        <div className="lap-details-section">
            <LapChart lapDetails={lapDetails} />
            <button 
                onClick={() => setIsExpanded(!isExpanded)} 
                className="collapse-button"
                style={{ width: '100%', textAlign: 'left', padding: '10px', marginBottom: '10px' }}
            >
                {isExpanded ? '▼' : '▶'} Lap Details
            </button>
            {isExpanded && (
                <table className="lap-details-table">
                    <thead>
                        <tr>
                            <th>Lap</th>
                            <th>Duration</th>
                            <th>vs Avg</th>
                            <th>Cumulative</th>
                            <th>Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lapMetrics.metrics.map((lap, index) => (
                            <tr key={index}>
                                <td>{lap.lapNumber}</td>
                                <td>{lap.formattedDuration}</td>
                                <td style={{ color: lap.diffFromAvg < 0 ? '#4caf50' : lap.diffFromAvg > 0 ? '#ff6b6b' : 'inherit' }}>
                                    {lap.pace !== 'N/A' ? `${lap.pace > 0 ? '+' : ''}${lap.pace}%` : 'N/A'}
                                </td>
                                <td>{formatTime(lap.cumulativeTime)}</td>
                                <td>{lap.time?.toLocaleTimeString?.() || lap.time?.toLocaleString?.() || 'unknown'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default LapDetailsSection;
